import React from "react";
import { Col, Row } from "reactstrap";
import ImageField from "./ImageField";

// Google shows roughly this much of a title / description in results.
const TITLE_LIMIT = 60;
const DESC_LIMIT = 160;
const SITE = "ryzhm.com";

const Counter = ({ length, limit }) => (
  <span className={`fs-12px ${length > limit ? "text-danger" : "text-soft"}`}>
    {length}/{limit}
    {length > limit ? " — will be cut off in Google" : ""}
  </span>
);

/**
 * Meta title / description / keywords / share image, with a live preview of
 * the Google result. `fallbackTitle` is shown when the meta title is empty
 * (the storefront then uses the page title). Titles get " | RYZHM" appended
 * on the site unless noted.
 */
export default function SeoFields({ value, onChange, path, fallbackTitle, appendsBrand = true, showKeywords = true, showImage = true }) {
  const set = (field) => (e) => onChange({ ...value, [field]: e.target.value });
  const shownTitle = `${value.meta_title || fallbackTitle || ""}${appendsBrand ? " | RYZHM" : ""}`;

  return (
    <div>
      <div className="border rounded p-3 mb-3 bg-lighter">
        <div className="fs-12px text-soft mb-1">Google preview</div>
        <div style={{ color: "#1a0dab", fontSize: 18, lineHeight: 1.3 }}>{shownTitle}</div>
        <div style={{ color: "#006621", fontSize: 13 }}>
          {SITE}
          {path}
        </div>
        <div style={{ color: "#545454", fontSize: 13 }}>{value.meta_description || "—"}</div>
      </div>

      <Row className="g-3">
        <Col md={12}>
          <div className="form-group">
            <div className="d-flex justify-content-between">
              <label className="form-label">Meta title</label>
              <Counter length={shownTitle.length} limit={TITLE_LIMIT} />
            </div>
            <input type="text" className="form-control" maxLength={255} value={value.meta_title} onChange={set("meta_title")} placeholder={fallbackTitle} />
          </div>
        </Col>
        <Col md={12}>
          <div className="form-group">
            <div className="d-flex justify-content-between">
              <label className="form-label">Meta description</label>
              <Counter length={value.meta_description.length} limit={DESC_LIMIT} />
            </div>
            <textarea className="form-control" rows={3} maxLength={500} value={value.meta_description} onChange={set("meta_description")} />
          </div>
        </Col>
        {showKeywords && (
          <Col md={12}>
            <div className="form-group">
              <label className="form-label">Keywords (comma separated)</label>
              <input type="text" className="form-control" maxLength={500} value={value.keywords ?? ""} onChange={set("keywords")} placeholder="long lasting perfume, perfume made in india" />
            </div>
          </Col>
        )}
        {showImage && (
          <Col md={12}>
            <ImageField
              label="Share image (WhatsApp / Facebook preview)"
              value={value.og_image ?? ""}
              onChange={(og_image) => onChange({ ...value, og_image })}
              hint="1200 × 630 px works best. Empty = the site's default image."
            />
          </Col>
        )}
      </Row>
    </div>
  );
}
